import { Fragment, forwardRef, useImperativeHandle, useState } from 'react';
import { Card, CardHeader } from 'reactstrap';
import { ColourIndicator, Loader, Table } from '../../../common/components';
import { equityTableColumns } from '../../../utils/constant';
import { getPrice } from '../../../utils/formatters';
import ItemEmptyTile from '../../reports/item-empty-tile/item-empty-tile';

const PERIOD_COLUMNS = [
  { period: '0-12m', equityKey: 'month12Equity', otherKey: 'month12OtherEquity' },
  { period: '13-24m', equityKey: 'month24Equity', otherKey: 'month24OtherEquity' },
  { period: '25-36m', equityKey: 'month36Equity', otherKey: 'month36OtherEquity' },
  { period: 'above-36', equityKey: 'above36Equity', otherKey: 'above36OtherEquity' },
];

const EQUITY_TABLE_COLUMN_WIDTHS = [
  '180px',
  '200px',
  '150px',
  '115px',
  '180px',
  '115px',
  '180px',
  '115px',
  '180px',
  '115px',
  '180px',
];

export default forwardRef(function EquityOnCancelledTable(_props, ref) {
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);

  useImperativeHandle(ref, () => ({ getProjectionData }));

  const getProjectionData = (err, res) => {
    if (err) return;
    const { miniloading, data } = res || {};
    setLoading(miniloading);
    if (miniloading) return;
    const { getProjection } = data || {};
    setTableData(getProjection?.data?.result?.equityOnCancelledContracts || []);
  };

  return (
    <div>
      <Card className="table-equity">
        <CardHeader>
          <ul>
            <li className="title">Equity on Cancelled Contracts</li>
            <li className="equity-colorcode">
              <ColourIndicator label="Current period" colour="#B9F1EE" />
            </li>
          </ul>
        </CardHeader>
        {tableData && tableData.length > 0 ? (
          <Table
            headers={equityTableColumns}
            bordered
            nestedHeaders
            responsive
            columnWidths={EQUITY_TABLE_COLUMN_WIDTHS}
            className="trust-equity-table"
          >
            <tbody>
              {tableData.length > 0
                ? tableData.slice(1).map((columnData) => (
                    <tr key={columnData?.onePortalId} className="table-body-tr trust-equ-tr">
                      <td>{columnData?.onePortalId}</td>
                      <td>{columnData?.purchaserName}</td>
                      <td>{columnData?.contractNumber}</td>
                      {PERIOD_COLUMNS.map(({ period, equityKey, otherKey }) => (
                        <Fragment key={period}>
                          <td
                            className={columnData?.currentPeriod === period ? 'current-period' : ''}
                          >
                            {getPrice(columnData?.[equityKey])}
                          </td>
                          <td
                            className={columnData?.currentPeriod === period ? 'current-period' : ''}
                          >
                            {getPrice(columnData?.[otherKey])}
                          </td>
                        </Fragment>
                      ))}
                    </tr>
                  ))
                : null}
            </tbody>
          </Table>
        ) : (
          <ItemEmptyTile />
        )}
        {loading && <Loader />}
      </Card>
    </div>
  );
});
